import type { ReactNode } from 'react'
import clsx from 'clsx'
import TruncatedText from '@/components/truncated-text/TruncatedText'
import { ArrowUpRight } from '@/assets/icons'

export function WorkProductCardIcon({ active, children }: { active: boolean; children: ReactNode }) {
  return (
    <span
      className={clsx(
        'flex items-center justify-center w-full h-full border-r',
        active
          ? 'bg-surface-selected border-brand-neutral-400 text-brand-500'
          : 'bg-surface-subtle border-border-strong text-text-tertiary hover-capable:group-hover:bg-surface-hover-strong'
      )}
    >
      {children}
    </span>
  )
}

export function WorkProductCardOpenLabel({ active, activeLabel = 'Open' }: { active: boolean; activeLabel?: string }) {
  return (
    <span className="text-[12px] text-text-tertiary flex items-center leading-tight">
      <span>{active ? activeLabel : 'Open'}</span>
      {active ? (
        <span aria-hidden="true" className="ml-[4.5px] mt-[1px] shrink-0 w-[5px] h-[5px] bg-brand-500 rounded-full" />
      ) : (
        <ArrowUpRight aria-hidden="true" className="w-3.5 h-3.5 ml-[3px] shrink-0" />
      )}
    </span>
  )
}

export function WorkProductCardContent({ children }: { children: ReactNode }) {
  return <span className="flex min-w-0 flex-col justify-center p-3">{children}</span>
}

/** Shared card body; the parent marks the boundary that excludes Markdown resets. */
export function WorkProductCardContents({ active, icon, title, activeLabel }: { active: boolean; icon: ReactNode; title: ReactNode; activeLabel?: string }) {
  return (
    <>
      <WorkProductCardIcon active={active}>{icon}</WorkProductCardIcon>
      <WorkProductCardContent>
        {typeof title === 'string' ? (
          <TruncatedText offsetX={-5} offsetY={-8} className="text-[13px] text-left font-medium leading-tight mb-1" disableOnTouch>
            {title}
          </TruncatedText>
        ) : (
          <span className="text-[13px] text-left font-medium leading-tight mb-1 truncate">{title}</span>
        )}
        <WorkProductCardOpenLabel active={active} activeLabel={activeLabel} />
      </WorkProductCardContent>
    </>
  )
}
